if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.unreachedMessage = this.querySelector('.free-shipping-bar__unreached-message');
      this.reachedMessage = this.querySelector('.free-shipping-bar__reached-message');
      this.bundleMessage = this.querySelector('.free-shipping-bar__bundle-message');
      this.progressWrapper = this.querySelector('.free-shipping-bar__progress-wrapper');
      this.bundleDiscount = this.dataset.bundleDiscount === 'true';
      if(this.unreachedMessage) {
        this.unreachedMessageText = this.unreachedMessage.innerHTML;
      }
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      if (this.dataset.showExcludeMessage) {
        this.countExcludeProducts = parseInt(this.dataset.countExcludeProducts);
        this.excludeMessage = this.querySelector('.free-shipping-bar__exclude-message');
        this.excludeMessageText = this.excludeMessage.innerHTML;
        this.toggleExcludeMessage()
      }
      if(!this.dataset.threshold) return;
      this.threshold = parseInt(this.dataset.threshold);
      this.calculateBar(parseInt(this.dataset.total));
      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (cartIcon) {
        this.lastCartSummary = cartIcon.textContent;
        this.cartObserver = new MutationObserver(() => {
          const summary = cartIcon.textContent;
          if (summary !== this.lastCartSummary) { this.lastCartSummary = summary; this.onCartChange(); }
        });
        this.cartObserver.observe(cartIcon, { childList: true, subtree: true, characterData: true });
      }
    }

    disconnectedCallback() {
      this.cartRequestId = (this.cartRequestId || 0) + 1;
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
      if (this.cartObserver) this.cartObserver.disconnect();
    }

    hasBundleDiscount(cart) {
      return Array.isArray(cart?.items) && cart.items.some(item =>
        Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.some(allocation =>
          String(allocation.discount_application?.title || '').trim().toUpperCase().startsWith('BOGOS')
        )
      );
    }

    calculateBar(currentTotal) {
      this.bundleMessage?.classList.toggle('hidden', !this.bundleDiscount);
      this.progressWrapper?.classList.toggle('hidden', this.bundleDiscount);
      if (this.bundleDiscount) {
        this.classList.remove('completed');
        this.hideUnreachedMessage();
        this.hideReachedMessage();
        return;
      }
      const total = currentTotal / parseFloat(Shopify.currency.rate);
      if(total >= this.threshold) {
        this.style.setProperty('--percent', '100%');
        this.classList.add('completed');
        this.hideUnreachedMessage();
        this.showReachedMessage();
        this.percentNumber.textContent = `100%`;
      }  else {
        this.classList.remove('completed');
        const remain = this.threshold - total;
        const percent = (total * 100) / this.threshold;
        this.style.setProperty('--percent', `${percent}%`);
        this.hideReachedMessage();
        this.showUnreachedMessage(remain);
        this.percentNumber.textContent = `${Math.floor(percent)}%`;
      }
    }

    toggleExcludeMessage() {
      if (!this.dataset.showExcludeMessage) {
          return
      }
      if (this.bundleDiscount || !this.countExcludeProducts) {
          this.excludeMessage.classList.add('hidden')
      } else {
          this.excludeMessage.innerHTML = this.excludeMessageText.replace('[product_count]', this.countExcludeProducts);
          this.excludeMessage.classList.remove('hidden')
      }
    }

    onCartChange() {
      const requestId = this.cartRequestId = (this.cartRequestId || 0) + 1;
      return fetch(`${routes.cart_url}.js`, {...fetchConfig('json', 'GET'), cache: 'no-store'})
      .then((response) => {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      })
      .then((response) => {
        if (requestId !== this.cartRequestId || !this.isConnected || !Array.isArray(response.items) || !Number.isFinite(response.total_price)) return;
        this.bundleDiscount = this.hasBundleDiscount(response);
        this.countExcludeProducts = 0;
        let totalPrice = response.total_price;
        if (freeShippingBarExcludeProducts.length > 0 && response.items.length > 0) {
          response.items.forEach((item) => {
            if(freeShippingBarExcludeProducts.includes(item.product_id)) {
              totalPrice -= item.final_line_price;
              this.countExcludeProducts++
            }
          });
        }
        this.calculateBar(totalPrice);
        this.toggleExcludeMessage()
      }).catch(() => { /* Keep the last confirmed total if the refresh fails. */ });
    }

    showUnreachedMessage(remainAmount) {
      if(!this.unreachedMessageText && this.unreachedMessage) return;
      const remainPrice = Shopify.showPrice(remainAmount);
      this.unreachedMessage.classList.remove('hidden');
      this.unreachedMessage.innerHTML = this.unreachedMessageText.replace('[remain]', `${remainPrice}`);
    }

    hideUnreachedMessage() {
      if(!this.unreachedMessage) return;
      this.unreachedMessage.classList.add('hidden');
    }

    showReachedMessage(remainAmount) {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.remove('hidden')
    }

    hideReachedMessage() {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.add('hidden');
    }
  });
}
